import { create } from 'zustand';

// UI-related state for gang management (search only - panel state moved to gangsPanelStore)
interface GangManagementUIState {
  searchText: string;
}

interface GangManagementUIActions {
  // Search actions
  setSearchText: (text: string) => void;
  clearSearch: () => void;
}

export const useGangManagementUIStore = create<
  GangManagementUIState & GangManagementUIActions
>(set => ({
  // State initialization
  searchText: '',

  // Search actions
  setSearchText: (text: string) => set({ searchText: text }),
  clearSearch: () => set({ searchText: '' }),
}));
